import * as React from "react"
import { SVGProps } from "react"
const OrderCreatedCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={102} height={102} {...props}>
    <defs>
      <linearGradient
        id="a"
        x1={0.129}
        x2={0.867}
        y1={0.163}
        y2={0.875}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#31bdbf" />
        <stop offset={1} stopColor="#3f76a5" />
      </linearGradient>
    </defs>
    <g data-name="Group 18790">
      <g data-name="Component 6407 \u2013 3">
        <g fill="url(#a)" stroke="#18b5b7" data-name="Ellipse 667">
          <circle cx={51} cy={51} r={51} stroke="none" />
          <circle cx={51} cy={51} r={50.5} fill="none" />
        </g>
      </g>
      <g data-name="Group 13624">
        <path
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={10}
          d="m26.434 51.153 16.529 16.528L76.02 34.624"
          data-name="Path 5128"
        />
      </g>
    </g>
  </svg>
)
export default OrderCreatedCheck
